import React from 'react'
import MarektingMarClusterList from '../../features/marketingManager/MarektingMarClusterList'

const MarektingMarClusterListPage = () => {
    return (
        <MarektingMarClusterList />
    )
}

export default MarektingMarClusterListPage